/**
 * Shared header + max-width for the transform editor dialogs (pattern, value-map,
 * constant) — they all show a title and a "Kolumna: X" subtitle inside the same
 * ModalDialog shell.
 */
import { InfoHint } from '@ooh/ui/components/info-hint';

export const TRANSFORM_DIALOG_MAX_WIDTH = 'max-w-lg';

export interface TransformDialogHeaderProps {
  title: string;
  columnLabelPrefix: string;
  sourceColumnLabel: string;
  /** Accessible label for the "(i)" info affordance next to the title. Omit to skip
   * rendering the info hint (the constant dialog doesn't need one). */
  infoLabel?: string;
  /** Body copy for the info hint — omit to skip rendering it. */
  infoText?: string;
}

export function TransformDialogHeader({
  title,
  columnLabelPrefix,
  sourceColumnLabel,
  infoLabel,
  infoText,
}: TransformDialogHeaderProps) {
  return (
    <div>
      <div className="flex items-center gap-1.5">
        <h2 className="text-base font-semibold">{title}</h2>
        {infoText ? <InfoHint label={infoLabel}>{infoText}</InfoHint> : null}
      </div>
      <p className="text-xs text-muted-foreground mt-0.5">
        {columnLabelPrefix} <span className="font-mono">{sourceColumnLabel}</span>
      </p>
    </div>
  );
}
